import React from 'react';

import Logo from '../../assets/images/favicon-192x192.png';

import classes from './Spinner.module.scss';

const Spinner = ({ className }) => {
  const loadingClasses = [classes.icon];
  if (className) {
    loadingClasses.push(className);
  }
  return <img className={loadingClasses.join(' ')} src={Logo} alt='Loading Icon' />;
};

export default Spinner;
